var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"toTop"},[_c('nav-bar-vue'),_c('transition',{attrs:{"name":"fade"}},[_c('keep-alive',{attrs:{"include":_vm.cashViews}},[_c('router-view')],1)],1),_c('v-footer')],1),_c('el-backtop',{attrs:{"target":".toTop"}},[_c('div',[_c('div',[_vm._v("回到顶部")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }